import React from 'react';
import { AcceptedProps } from './interface/accepted-props';
const GapField: React.FC<AcceptedProps> = (props) => {
  return <div className={`field-gap`}></div>
}

export default GapField;